export const DYNAMIC_PAGE_PATHS = {
  HOME: '/',
  ACCOUNT: '/account',
  FUNNEL: '/funnel',

  // Applications
  CONSUMER_LOAN_LIST: '/loan/',
  AUTO_LOAN_LIST: '/autoloan/',
  CREDIT_LINE_LIST: '/creditline/',
  CREDIT_CARD_LIST: '/credit-card/',
  ORDER_LIST: '/order/',
  PAY_BY_LINK_LIST: '/paybylink/',
  A2A_PAYMENT_LIST: '/a2a-payment/',
  CARD_PAYMENT_LIST: '/card-payment/',

  CONSUMER_LOAN: '/loan/:loanId',
  DOCUMENTS_VALIDATION: '/loan/:loanId/validation/',
  AUTO_LOAN: '/autoloan/:loanId',
  CREDIT_LINE: '/creditline/:loanId',
  CARD: '/card/:loanId',
  ORDER: '/order/:loanId',
  PAY_BY_LINK: '/paybylink/:loanId',
  A2A_PAYMENT: '/a2a-payment/:paymentMethodId',
  CARD_PAYMENT: '/card-payment/:paymentMethodId',
  CREDIT_CARD: '/credit-card/:creditCardId',

  MERCHANT_LIST: '/merchant/',
  MERCHANT: '/merchant/:merchantId',

  CHANNEL: '/merchant/:merchantId/channel/:channelId',

  AGENT: '/merchant/:merchantId/channel/:channelId/agent/:agentId',

  BORROWER_LIST: '/borrower/',
  BORROWER: '/borrower/:borrowerId',

  PAYOUTS_LIST: '/payout/',
  PAYOUT: '/payout/:payoutId',

  PRICINGS_LIST: '/pricing/',
  PRICING_EDITOR: '/pricing/:pricingId',
  PRICING_CREATE: '/pricing/new',

  APPLICATION: '/application/',

  SIMULATOR: '/simulator',
  CHECKOUT_SESSION_LIST: '/checkout-session/',
  CHECKOUT_SESSION_DETAIL: '/checkout-session/:checkoutSessionId',

  INSIGHTS: '/insights/',

  INTEGRATIONS: '/integrations',

  REPORTS_LIST: '/report/',
  REPORT: '/report/:reportId',

  USERS: '/users',
} as const;
